import { ElMessage } from 'element-plus'

const chkErrorMessage = (err, repeat = true) => {
  if (err.code && err.code == 4902 && err.message.indexOf('Unrecognized chain ID') == 0) {
    _sendMsg('Please add the chain first in MetaMask.', repeat)
  } else if (err != 'No guild membership') {
    _sendMsg(err, repeat)
  }
}

let _previousMsg = ''
const _sendMsg = (err, repeat) => {
  const msg = err.message || err
  if (repeat || msg != _previousMsg) {
    ElMessage({
      message: msg,
      type: 'error',
      showClose: true,
    })
  }
  if (!repeat) {
    _previousMsg = msg
  }
}

export default chkErrorMessage
